import React, { createContext, useContext, useState } from "react"
import { translations } from "./translations"

const LangContext = createContext({ t: translations.en, lang: "en", setLang: () => {} })

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en"
    const saved = localStorage.getItem("lang")
    if (saved && translations[saved]) return saved
    const browser = navigator.language.slice(0, 2).toLowerCase()
    return translations[browser] ? browser : "en"
  })

  const handleSetLang = (l) => {
    setLang(l)
    localStorage.setItem("lang", l)
  }

  return (
    <LangContext.Provider value={{ t: translations[lang], lang, setLang: handleSetLang }}>
      {children}
    </LangContext.Provider>
  )
}

export const useLang = () => useContext(LangContext)
